export function replacePlaceholders(content: string, placeholders: Record<string, string | undefined>): string {
    if (Object.keys(placeholders).length === 0) {
        return content
    }

    for (const [key, value] of Object.entries(placeholders)) {
        if (value !== undefined) {
            const placeholder = `{${key}}`
            content = content.replace(new RegExp(placeholder, "g"), value)
        }
    }

    return content
}
